import { Variant } from 'react-bootstrap/esm/types';
import { Styles } from 'react-select';
import { plt } from 'src/services/GrpcService';
import { ElementSlugEnum, OrderPaymentTypeEnum } from '../../../../../services/GraphQL';
import { PaymentType } from './interfaces/payments';

export const OrderStatusToBadgeVariantMapping: Record<plt.core.base.ORDER_STATUS_TYPE, Variant> = {
  [plt.core.base.ORDER_STATUS_TYPE.UNKNOWN_ORDER_STATUS_TYPE]: 'info',
  [plt.core.base.ORDER_STATUS_TYPE.TODO]: 'primary',
  [plt.core.base.ORDER_STATUS_TYPE.IN_PROGRESS]: 'primary',
  [plt.core.base.ORDER_STATUS_TYPE.DONE]: 'success',
  [plt.core.base.ORDER_STATUS_TYPE.CANCELED]: 'danger',
  [plt.core.base.ORDER_STATUS_TYPE.ON_COORDINATION]: 'primary',
  [plt.core.base.ORDER_STATUS_TYPE.WAIT_IN_PICKPOINT]: 'info',
};

export const OrderStatusToTextMapping: Record<plt.core.base.ORDER_STATUS_TYPE, string> = {
  [plt.core.base.ORDER_STATUS_TYPE.UNKNOWN_ORDER_STATUS_TYPE]: 'Неизвестный',
  [plt.core.base.ORDER_STATUS_TYPE.TODO]: 'Подтвержден',
  [plt.core.base.ORDER_STATUS_TYPE.IN_PROGRESS]: 'В работе',
  [plt.core.base.ORDER_STATUS_TYPE.DONE]: 'Выполнен',
  [plt.core.base.ORDER_STATUS_TYPE.CANCELED]: 'Отменён',
  [plt.core.base.ORDER_STATUS_TYPE.ON_COORDINATION]: 'На проверке',
  [plt.core.base.ORDER_STATUS_TYPE.WAIT_IN_PICKPOINT]: 'Ожидает в пункте выдачи',
};

export const OrderPaymentStatusToBadgeVariantMapping: Partial<Record<plt.core.base.PAYMENT_STATUS_TYPE, Variant>> = {
  [plt.core.base.PAYMENT_STATUS_TYPE.canceled]: 'warning',
  [plt.core.base.PAYMENT_STATUS_TYPE.failed]: 'danger',
  [plt.core.base.PAYMENT_STATUS_TYPE.new]: 'warning',
  [plt.core.base.PAYMENT_STATUS_TYPE.authorized]: 'success',
  [plt.core.base.PAYMENT_STATUS_TYPE.paid]: 'success',
  [plt.core.base.PAYMENT_STATUS_TYPE.to_refund]: 'warning',
  [plt.core.base.PAYMENT_STATUS_TYPE.refunded]: 'danger',
};

export const OrderPaymentStatusToTextMapping: Partial<Record<plt.core.base.PAYMENT_STATUS_TYPE, string>> = {
  [plt.core.base.PAYMENT_STATUS_TYPE.canceled]: 'Не оплачен',
  [plt.core.base.PAYMENT_STATUS_TYPE.failed]: 'Ошибка оплаты',
  [plt.core.base.PAYMENT_STATUS_TYPE.new]: 'Не оплачен',
  [plt.core.base.PAYMENT_STATUS_TYPE.authorized]: 'Оплачен',
  [plt.core.base.PAYMENT_STATUS_TYPE.paid]: 'Оплачен',
  [plt.core.base.PAYMENT_STATUS_TYPE.to_refund]: 'К возврату',
  [plt.core.base.PAYMENT_STATUS_TYPE.refunded]: 'Возвращен',
};

export const OrderPaymentTypeEnumMapping: Partial<Record<PaymentType, OrderPaymentTypeEnum>> = {
  [PaymentType.Card]: OrderPaymentTypeEnum.CARD_ONLINE,
  [PaymentType.Cash]: OrderPaymentTypeEnum.CLIENT_CASH,
  [PaymentType.ContractorCardLinked]: OrderPaymentTypeEnum.CONTRACTOR_CARD_LINKED,
  [PaymentType.InstallmentPlan]: OrderPaymentTypeEnum.INSTALLMENT_PLAN,
  [PaymentType.Sms]: OrderPaymentTypeEnum.CLIENT_SMS,
  [PaymentType.SoftPos]: OrderPaymentTypeEnum.SOFT_POS,
  [PaymentType.Link]: OrderPaymentTypeEnum.LINK,
};

export const PAYMENT_TYPE_CASH = '0';

export const ANY_CLEANER_ID = '0';

export const VIP_SERVICE_POINT_ID = '9df1ee75-83a1-4f60-9e2c-d7a2bb23d1a9';

export const WIDE_SELECT_STYLES: Partial<Styles> = {
  menu: (styles) => ({ ...styles, width: '600px', padding: '0.75rem 1rem' }),
};

export const SELL_GOODS_SERVICE_TYPES = {
  SELL_GOODS_NEW: 'sell_goods_new',
  SELL_GOODS_CHEMISTRY: 'sell_goods_chemistry',
};

export const PLT_PRODUCTS_SERVICE_TYPES = {
  PLT_DRYCLEANING_CARPET: 'plt_drycleaning_carpet',
  PLT_DRYCLEANING_CURTAINS: 'plt_drycleaning_curtains',
  PLT_DRYCLEANING_STROLLER: 'plt_drycleaning_stroller',
};

export const ORDER_SERVICE_TYPES = {
  ...SELL_GOODS_SERVICE_TYPES,
  ...PLT_PRODUCTS_SERVICE_TYPES,
};

export const TIMESLOTS_SERVICES = {
  LMS: 'lms',
};

export const TIMESLOTS_SERVICE_TYPE = {
  [ORDER_SERVICE_TYPES.SELL_GOODS_NEW]: TIMESLOTS_SERVICES.LMS,
  [ORDER_SERVICE_TYPES.SELL_GOODS_CHEMISTRY]: TIMESLOTS_SERVICES.LMS,
  [ORDER_SERVICE_TYPES.PLT_DRYCLEANING_CARPET]: TIMESLOTS_SERVICES.LMS,
  [ORDER_SERVICE_TYPES.PLT_DRYCLEANING_CURTAINS]: TIMESLOTS_SERVICES.LMS,
  [ORDER_SERVICE_TYPES.PLT_DRYCLEANING_STROLLER]: TIMESLOTS_SERVICES.LMS,
};
